import React, { Component } from 'react'
import classnames from "classnames"
import styles from "./Gallery.less"
import { ArrowRightThinIcon, ArrowLeftThinIcon, Modal, H2, H3, Visible, Section } from "AtomicComponents"
import { Image, Tabs, Slideshow } from "AtomicContainers"

class Gallery extends Component {
  constructor(props) {
    super(props)

    this.state = {
      modalActive: false,
      currentIndex: 0
    }
  }

  activateModal = (index) => {
    this.setState({
      modalActive: true,
      currentIndex: index
    })
  }

  deactivateModal = () => {
    this.setState({
      modalActive: false
    })
  }

  render() {
    const { imagesArray } = this.props
    const { currentIndex, modalActive } = this.state

    return (
      <Section fullWidth>
        <div className={classnames({ [styles.Gallery]: true })}>
          {imagesArray.map((image, index) => {
            return (
              <div
                key={index}
                className={classnames({
                  [styles.GalleryItem]: true
                })}
                onClick={() => {
                  this.activateModal(index)
                }}>
                <Image src={image.src} alt={image.name} />
              </div>
            )
          })}
          <H2 withDetails white>
            <Visible visible={["screen"]}>{imagesArray.length > 4 && `+${imagesArray.length - 4}`}</Visible>
            <Visible visible={["tablet", "mobile"]}>{imagesArray.length > 3 && `+${imagesArray.length - 3}`}</Visible>
          </H2>
          {
            modalActive &&
            <Modal
              fullWidth
              width="100%"
              handleClose={() => {
                this.setState({ modalActive: false })
              }}>
              <div className={classnames({ [styles.GalleryModal]: true })}>
                <div className={classnames({ [styles.GalleryModalBody]: true })}>
                  <H3 withDetails><span>{currentIndex + 1}</span> / {imagesArray.length}</H3>
                  <div className={classnames({ [styles.GalleryModalBodyImage]: true })}>
                    <Slideshow
                      contain
                      dotsEnabled={false}
                      activeIndex={currentIndex}
                      onClick={activeIndex => this.setState({ currentIndex: activeIndex })}
                      slides={imagesArray.map((item, index) => {
                        return {
                          name: `name-${index}`,
                          imageSrc: item.src
                        }
                      })}
                    />
                    {/* <Image src={imagesArray[currentIndex].src} alt={imagesArray[currentIndex].name} contain /> */}
                  </div>
                </div>
                <div className={classnames({ [styles.GalleryModalFooter]: true })}>
                  <div
                    className={classnames({
                      [styles.GalleryModalFooterArrow]: true,
                      [styles.GalleryModalFooterArrowDisabled]: currentIndex === 0,
                      [styles.GalleryModalFooterArrowLeft]: true
                    })}
                    onClick={() => {
                      this.setState(prevState => ({
                        currentIndex: prevState.currentIndex === 0 ? 0 : (prevState.currentIndex - 1)
                      }))
                    }}>
                    <ArrowLeftThinIcon />
                  </div>
                  <div className={classnames({ [styles.GalleryModalThumbnails]: true })}>
                    <Tabs
                      scrolling
                      activeIndex={currentIndex}
                      onClick={(index) => this.setState({ currentIndex: index })}>
                      {
                        imagesArray.map((image, index) => {
                          return (
                            <div
                              className={classnames({
                                [styles.Thumbnail]: true,
                                [styles.ThumbnailActive]: currentIndex === index
                              })}
                              key={index}>
                              <Image src={image.src} alt={image.name} />
                            </div>
                          )
                        })
                      }
                    </Tabs>
                  </div>
                  <div
                    className={classnames({
                      [styles.GalleryModalFooterArrow]: true,
                      [styles.GalleryModalFooterArrowDisabled]: currentIndex === (imagesArray.length - 1),
                      [styles.GalleryModalFooterArrowRight]: true
                    })}
                    onClick={() => {
                      this.setState(prevState => ({
                        currentIndex: prevState.currentIndex === (imagesArray.length - 1) ? prevState.currentIndex : (prevState.currentIndex + 1)
                      }))
                    }}>
                    <ArrowRightThinIcon />
                  </div>
                </div>
              </div>
            </Modal>
          }
        </div>
      </Section>
    )
  }
}

export default Gallery



// WEBPACK FOOTER //
// ./src/AtomicContainers/Gallery/Gallery.jsx